import i18next from 'i18next';

i18next.addResources('es', 'stage-progress', { label: 'Etapa: {{stage}} ({{position}} de {{total}})' });
i18next.addResources('en', 'stage-progress', { label: 'Stage: {{stage}} ({{position}} of {{total}})' });
i18next.addResources('pt', 'stage-progress', { label: 'Etapa: {{stage}} ({{position}} de {{total}})' });
